import { render, staticRenderFns } from "./SetupProject.vue?vue&type=template&id=1580754a&scoped=true&"
import script from "./SetupProject.vue?vue&type=script&lang=js&"
export * from "./SetupProject.vue?vue&type=script&lang=js&"
import style0 from "./SetupProject.vue?vue&type=style&index=0&id=1580754a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580754a",
  null
  
)

export default component.exports